<template>
  <markeradscaro />
</template>

<script>
import markeradscaro from "@/components/markerAdsCaro"
export default {
    name: 'Ourservices',
    
    components : {
        markeradscaro,
    }
}
</script>

<style>

</style>